// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7a08ab60","453":"a94b8769","732":"708d19c4","977":"de61966e"}[chunkId] + ".chunk.js";
};